import { ERROR_MESSAGES } from 'constants/validation-error-messages';
import * as yup from 'yup';

export const certificateSchema = yup.object({
    city: yup.string().required(ERROR_MESSAGES.REQUIRED),
    date: yup.string().required(ERROR_MESSAGES.REQUIRED),
    coordinator: yup.string().required(ERROR_MESSAGES.REQUIRED),
    participants: yup.array(),
});
